import moment from 'moment'
import {FC, ReactNode} from 'react'
import DateRangePicker from 'react-bootstrap-daterangepicker'

type Props = {
  startDate?: any | undefined
  onCallback?: (start: any) => void
  placeholder?: string | undefined
  pickerRef?: React.LegacyRef<DateRangePicker> | undefined
  disabled?: boolean
  readOnly?: boolean
  timePicker?: boolean
  timePicker24Hour?: boolean
  customInput?: ReactNode
  minDate?: any
  maxDate?: any
}

const SingleDatePicker: FC<Props> = ({
  startDate,
  onCallback,
  placeholder,
  pickerRef,
  disabled,
  readOnly,
  timePicker,
  timePicker24Hour,
  customInput,
  minDate,
  maxDate,
}) => {
  return (
    <DateRangePicker
      ref={pickerRef}
      initialSettings={{
        singleDatePicker: true,
        showDropdowns: true,
        startDate,
        timePicker: timePicker ?? false,
        timePicker24Hour: timePicker24Hour ?? false,
        minDate: minDate,
        maxDate: maxDate
      }}
      onCallback={onCallback}
    >
      {customInput ? (
        customInput
      ) : (
        <input
          type='text'
          className='form-control w-100 pe-10'
          placeholder={placeholder}
          disabled={disabled}
          readOnly={readOnly}
        />
      )}
    </DateRangePicker>
  )
}

export {SingleDatePicker}
